module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/id/5-4de798eb17016653591b9aa6367ddfaf.jpg";